// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__FGuJH","modalLink":"Modal_modalLink__51hez","modalBuy":"Modal_modalBuy__qS78B"};